export const SET_LANGUAGE = "SET_LANGUAGE";
export const GET_LANGUAGE = "GET_LANGUAGE";
